import React from "react";
import { FC } from "react";

export interface CommonLayoutProps {
  index: string;
  nextHref: string;
  backtHref: string;
  nextBtnText?: string;
  children: React.ReactNode;
}

const CommonLayout: FC<CommonLayoutProps> = ({ index = "01", children }) => {
  return (
    <div
      className={`nc-PageAddListing1 px-4 max-w-3xl mx-auto pb-4 pt-14 sm:py-24 lg:pb-2`}
      data-nc-id="PageAddListing1"
    >
      <div className="space-y-11">
        <div>
          <span className="text-4xl font-semibold">{index}</span>{" "}
          <span className="text-lg text-neutral-500 dark:text-neutral-400">
            / 9
          </span>
        </div>
        <div className="listingSection__wrap ">{children}</div>
      </div>
    </div>
  );
};

export default CommonLayout;
